var xP = require('../xP');

module.exports = {
  name: 'computed', base: '_item', prototype: {
    process: function () {
      xP.debug('computed', 'computed', this.to.first().$element, this.to);

      xP.dependencies.classed.base.process.apply(this);

      var that = this;

      this.to.each(function () {
        if (that['do']) {
          this.param(that['do'], that.result);
        } else {
          this.val(that.result);
        }
      });
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/dependencies/computed.js
 ** module id = 43
 ** module chunks = 0
 **/